<template>
  <div class="news-info-container">
    <head-bar title="新闻详情" :border="true" :fixed="true"></head-bar>
    <div class="news-title">
      <span>{{title}}</span>
      <br />
      <em>{{createTime}}</em>
    </div>
    <div class="news-content-box" ref="container"></div>
  </div>
</template>
<script>
import { mount } from "@/utils/v_node";
import HeadBar from "@/components/HeadBar.vue";
export default {
  name: "Info",
  components: {
    HeadBar
  },
  data() {
    return {
      title: "",
      content: "",
      createTime: "",
      vNode: []
    };
  },
  beforeMount() {
    let { id } = this.$route.query;
    this.getNewsInfo(id);
  },
  methods: {
    getNewsInfo(newsId) {
      let _this = this;
      this.$axios
        .post(_this.$api.newsApi.getContent, {
          newsId: newsId
        })
        .then(res => {
          let { content, title, createTime, mobileJson } = res.data;
          let vNodeList = (_this.vNode = JSON.parse(mobileJson));
          _this.title = title;
          _this.content = content;
          _this.createTime = createTime;
          mount(vNodeList, _this.$refs.container);
        });
    }
  }
};
</script>
<style lang="less">
.news-info-container {
  padding: 100px 0;
  overflow: hidden;
  max-width: 750px;
  > .news-title {
    font-size: 36px !important;
    line-height: 1.5;
    text-align: center;
    em {
      font-size: 24px;
    }
  }
}
.news-info-container {
  > .news-content-box {
    padding: 10px 20px;
    font-size: 26px;
    line-height: 1.5;
    img {
      display: block;
      margin: 5px auto;
      max-width: 100% !important;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 32px;
    }
  }
}
</style>
